// @flow
import React from 'react';

import styles from './ETADisplay.css';

type ETADisplayPropTypes = {
  eta?: string,
  isCompleted?: boolean,
  isSelected?: boolean,
};

const ETADisplay = ({
  eta = 'N/A',
  isCompleted = false,
  isSelected = false,
}: ETADisplayPropTypes) => (
  <div className={`
    ${styles.etaContainer}
    ${isSelected ? styles.selected : ''}
  `}>
    <div className={`${styles.etaLabel}`}>
      {isCompleted ? 'COMPLETADO':'ETA'}
    </div>
    <div className={`${styles.etaValue}`}>
      {isCompleted ? '': eta}
    </div>
  </div>
);

export default ETADisplay;



// WEBPACK FOOTER //
// ./src/scripts/components/ETADisplay/index.jsx